<template>
  <div class="addr-box">
    <div>
      <van-form :show-error-message="false" validate-trigger="onChange" @submit="submit" @failed="failed">
        <!-- <div class="title-info flex-sb" @click="handleOpenSearch">
          <span class="details-address">{{mapCenterInfo.detailedAddress}}</span>
          <span style="font-size:12px;color:#A4A4A4;">更改</span>
        </div> -->
        <van-cell-group inset>
          <div class="input-box" style="margin-top:20px;" @click="handleOpenSearch">
            <van-field
              :value="mapCenterInfo.detailedAddress"
              name=""
              placeholder=""
              class="input"
              disabled
            />
            <span style="font-size:12px;color:#A6B6C6;flex-shrink:0;padding-right:16px;">更改</span>
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.remark"
              name="详细地址"
              placeholder="请输入详细门牌号"
              class="input"
              :rules="[{ validator: specialCharacterValid, message: '不支持空格及特殊符号' , trigger:'onChange' }]"
              @blur="formChange"
            />
          </div>
          <div class="input-box">
            <van-field
              v-model.trim="form.realName"
              name="姓名"
              placeholder="姓名"
              class="input"
              style="width:40%;"
              :rules="[
                { required: true, message: '请填写姓名' },
                { pattern: /^(([a-zA-Z+\.?\·?a-zA-Z+]{2,30}$)|([\u4e00-\u9fa5+\·?\u4e00-\u9fa5+]{2,30}$))/, message: '请填写正确的姓名' },
              ]"
              @blur="formChange"
            />
            <van-field
              v-model.trim="form.phoneNumber"
              name="手机/座机"
              placeholder="手机/座机"
              class="input"
              :rules="[
                { required: true, message: '请填写手机/座机' },
                { pattern: /^((0\d{2,3}-\d{7,8})|(1\d{10})|(\d{7,8}))$/, message: '请填写正确的手机/座机' },
              ]"
              @blur="formChange"
            />
          </div>
        </van-cell-group>
        <div class="footer">
          <van-checkbox 
            v-model="form.usualAddress" 
            checked-color="#F1892E" 
            icon-size="14px" 
            v-if="['homeStart','homeEnd','usualStart','usualEnd','editUsualStart','editUsualEnd'].includes(queryParams.pagesType)" 
            @change="checkboxChange"
          >存入常用地址</van-checkbox>
          <van-checkbox 
            v-model="form.selected" 
            checked-color="#F1892E" 
            icon-size="14px" 
            v-if="['userAddressBookAdd','userAddressBookEdit'].includes(queryParams.pagesType)"
            @change="checkboxChange"
          >设为默认地址</van-checkbox>
          <van-button 
            round 
            type="warning" 
            color="linear-gradient(129deg, #FB5084 0%, #FE4341 100%)" 
            native-type="submit" 
            class="footer-button"
            :disabled="!mapLoaded||getCenterLoading"
          >{{submitName}}</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Image , Field , Cell , CellGroup , Form , Button , Toast , Checkbox, CheckboxGroup  } from 'vant';
export default {
  name:'dispatch-address-info',
  props:['mapCenterInfo','openSearch','queryParams','mapLoaded','getCenterLoading'],
  components:{ 
    [Image.name]: Image,
    [Form.name]: Form,
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
   },
  data(){
    return {
      form:{
        realName:'',
        phoneNumber:'',
        remark:'',
      },
    }
  },
  watch:{
    queryParams:{
      handler(val){
        this.form = this.deepClone(val)
      },
      deep:true,
      immediate:true
    }
  },
  created(){
    // 扩展API是否准备好，如果没有则监听“plusready"事件
    if (window.plus) {
      // this.handlePlusReady()
      plus.storage.setItem('address', {startAddress:'深圳四',type:true});
    } else {
      document.addEventListener('plusready', this.handlePlusReady, false)
    }
  },
  computed:{
    submitName(){
      if(['homeStart','usualStart','editUsualStart'].includes(this.queryParams.pagesType)) return '确认装货地址';
      else if(['homeEnd','usualEnd','editUsualEnd'].includes(this.queryParams.pagesType)) return '确认卸货地址';
      else if(this.queryParams.pagesType === 'userAddressBookAdd') return this.queryParams.type === 'start'?'新增装货地址':'新增卸货地址';
      else if(this.queryParams.pagesType === 'userAddressBookEdit') return this.queryParams.type === 'start'?'修改装货地址':'修改卸货地址';
      else return '确认';
    }
  },
  methods:{
    /* 特殊字符校验 */
    specialCharacterValid(val){
      // return Promise.resolve(!/[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\s]/im.test(val))
      return Promise.resolve(!/[`~!@#$%^&*_+=<>?:"{}|.\/;'\\[\]·~！@#￥%……&*——+={}|《》？：“”【】、；‘'。、\s]/im.test(val))
    },
    checkboxChange(value){
      this.formChange();
    },
    formChange(){
      this.$emit('update:queryParams',{
        ...this.queryParams,
        ...this.deepClone(this.form)
      })
    },
    handleOpenSearch(){
      this.$emit('update:openSearch',true);
    },
    urlEncode(param, key, encode) {
     if (param == null) return '';
     var paramStr = '';
     var t = typeof(param);
     if (t == 'string' || t == 'number' || t == 'boolean') {
         paramStr += '&' + key + '=' + param;
     } else {
         for (var i in param) {
             var k = key == null ? i: key + (param instanceof Array ? '[' + i + ']': '.' + i);
             paramStr += this.urlEncode(param[i], k, encode);
         }
     }
     return paramStr;
    },
    submit(){
      // window.postMessage({
      //   data:this.queryParams
      // });
      // window.localStorage.setItem('address',{startAddress:'深圳四',type:true})
      // window.postMessage('hello111')
      // window["myaddress"] = 'hello world';
      // window.uni.navigateBack({
			// 	delta:1
			// })
      let query_str = this.urlEncode(this.queryParams);
      uni.switchTab({
        url:'/pages/home/index?type=h5'+query_str
			})
    },
    failed({ errors }){
      Toast.fail(errors[0].message);
    }
  }
}
</script>

<style scoped lang="scss">
  .addr-box {
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      background-color: #FFEAD8;
      & > div {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        padding: 0 22px;
        background-color: #FFF;
        overflow: hidden;
      }
      * {
        color: #130A01;
      }
      .van-form {
        position: relative;
        z-index: 100000;
        .van-cell-group {
          margin: 0;
        }
        .title-info {
          height: 56px;
          // flex-wrap: wrap;
          overflow: hidden;
          .details-address {
            flex: 1;
            font-size: 16px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
          }
        }
        .group-addr {
          padding-left: 0;
          padding: 15px 0;
        }
        .input-box {
          height: 36px;
          overflow: hidden;
          background-color: #F5F5F5;
          border-radius: 6px;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          ::v-deep .van-field__body {
            height: 100%;
          }
          .input {
            background-color: #F5F5F5;
            height: 36px;
            font-size: 16px;
          }
        }
        .footer {
          margin-bottom: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .footer-button {
            height: 38px;
            padding: 0 20px;
            background: linear-gradient(129deg, #F1892E 0%, #F1BC3F 100%);
            border-radius: 20px 20px 20px 20px;
            font-size: 18px;
            font-weight: bold;
            user-select: none;
            .van-button__text {
              font-family: 'DIN-Medium';
              color: #FFF;
            }
          }
        }
      }
    }
  ::v-deep .van-field__label {
    font-size: 16px;
    color: #1E1E1E;
  }
  ::v-deep .van-hairline--top-bottom {
    &:after {
      border: none;
    }
  }
  ::v-deep .van-checkbox {
    .van-checkbox__label {
      font-size: 13px;
      color: #130A01;
    }
  }
  ::v-deep .van-field__control:disabled {
    color: #333 !important;
    -webkit-text-fill-color:#333 !important;
  }
</style>